import * as React from 'react'
const ScheduleIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M17.75 3.15H6.25a3.1 3.1 0 00-3.1 3.1v11.5a3.1 3.1 0 003.1 3.1h11.5a3.1 3.1 0 003.1-3.1V6.25a3.1 3.1 0 00-3.1-3.1zm1.9 5.35v9.25a1.9 1.9 0 01-1.9 1.9H6.25a1.9 1.9 0 01-1.9-1.9v-9.4h15.3zm0-1.5v.15H4.35v-.9a1.9 1.9 0 011.9-1.9h11.5a1.9 1.9 0 011.9 1.9z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M7.75 14.65a1.1 1.1 0 101.1 1.1 1.1 1.1 0 00-1.1-1.1zm4.25 0a1.1 1.1 0 101.1 1.1 1.1 1.1 0 00-1.1-1.1zm-4.25-4a1.1 1.1 0 101.1 1.1 1.1 1.1 0 00-1.1-1.1zm4.25 0a1.1 1.1 0 101.1 1.1 1.1 1.1 0 00-1.1-1.1zm4.25 0a1.1 1.1 0 101.1 1.1 1.1 1.1 0 00-1.1-1.1z" className="-primary-color" fill="#a5aab8"/>
    </svg>
    
  )
}

export default ScheduleIcon